define('app-SearchResults/modules/resultsList/viewModel',['./settings', 'util', '../../../app/utilities/urlKey', '../../../app-Search/core/service',
    '../../../app/ui/dialog', '../../core/broker', 'knockout', 'underscore', 'jquery-ui'],
    function (settings, util, UrlKey, Service, dialog, broker, ko, _) {
        return function (globalSettings) {
            var self = this;
            var $paginationLinks = $("#pagination_links_foot");


            self.TotalResults = ko.observable('Loading');
            self.numberOfDisplayResultsSelected = ko.observable(12);
            self.SearchResults = ko.observableArray([]);
            self.Locations = ko.observableArray([]);
            self.LastSortBy = '';
            self.startAt = 0;
            self.Loading = null;
            self.StartResultsFrom = ko.observable(0);
            self.CurrentSearchTerms = ko.observable([]);
            self.LastSearchTerms = [];
            self.UrlKey = new UrlKey();
            self.Service = new Service(globalSettings.searchStorageKey);
            self.SortBy = ko.observable(self.Service.isCruiseSearch() ? 'Departure date' : 'Price (lowest)');
            self.NumberOfPassengers = ko.observable(2);
            self.SearchCustomisations = '{}'; // We'll update these on load.
            self.IgnoreChanges = true;
            self.Key = '';
            self.mapButtonText = ko.observable('View on map');
            self.AvailableSortOptions = ko.observableArray([
                'Price (lowest)',
                'Price (highest)',
                'Departure date'
            ]);

            self.SelectSortOption = function (sort) {
                self.SortBy(sort);

                $(globalSettings.overallContainer + ' .sortOptionsDropdown').slideUp(120);

                util.triggerEvent("search", "selectSortOption");
                AdlAddUpdateItem('sortBy', sort);
                util.satelliteTrack('search results sort');
            };

            // if already a value in the urlsearch position field, then set the startat value to this
            var pagePosKey = self.UrlKey.Get(settings.pagePositionKey);

            if (pagePosKey != undefined && pagePosKey >= 1) {
                self.startAt = pagePosKey - 1;
            }

            // runs when user clicks a page number
            self.SelectPageNumber = function (data) {

                var searchHeight = 0

                if ($("#searchControl").is(':visible')) {
                    searchHeight = $("#searchControl").height() + 20;
                }

                //if less than 0 then this is a previous / next movement required
                if (data.val < 0) {
                    if (data.val === -1) {
                        var prevStartAt = self.startAt - self.numberOfDisplayResultsSelected(); // go previous
                        if (prevStartAt < 0) {
                            return;
                        }
                        self.startAt = prevStartAt;
                    }
                    if (data.val === -2) {
                        var nextStartAt = self.startAt + self.numberOfDisplayResultsSelected(); // go next
                        if (nextStartAt > self.TotalResults()) {
                            return;
                        }
                        self.startAt = nextStartAt;
                    }


                    self.UrlKey.Set(settings.pagePositionKey, self.startAt);

                    var sortBy = self.SortBy();
                    var searchTerms = self.CurrentSearchTerms();

                    self.LoadingFromScroll = true;
                    var resultsStartFrom = parseInt(self.StartResultsFrom());
                    resultsStartFrom = self.numberOfDisplayResultsSelected(); // Get selected number of results.
                    startAt = self.startAt;
                    resultsToGet = self.numberOfDisplayResultsSelected(); // Get selected number of results.
                    self.StartResultsFrom(resultsStartFrom);
                    self.UrlKey.Set(settings.chunkPositionKey, resultsStartFrom);
                    self.LoadData(searchTerms, sortBy, startAt);
                } else {
                    self.startAt = data.val - 1;
                    self.UrlKey.Set(settings.pagePositionKey, data.val - 1);

                    var sortBy = self.SortBy();
                    var searchTerms = self.CurrentSearchTerms();

                    self.LoadingFromScroll = true;
                    var resultsStartFrom = parseInt(self.StartResultsFrom());

                    resultsStartFrom = self.numberOfDisplayResultsSelected(); // Get selected number of results.
                    startAt = self.startAt;
                    resultsToGet = self.numberOfDisplayResultsSelected(); // Get selected number of results.

                    self.StartResultsFrom(resultsStartFrom);
                    self.UrlKey.Set(settings.chunkPositionKey, resultsStartFrom);
                    self.LoadData(searchTerms, sortBy, startAt);
                }
                $('html, body').animate({
                    scrollTop: $("#searchResults").offset().top - searchHeight
                }, 1000);

                // jquery stuff to manage the active state on the links
                $paginationLinks.find("li").removeClass('active');
                $paginationLinks.find("span.temp").remove();

                var AA_searchResultsPage = 1;
                var div = Math.floor(startAt / resultsToGet);
                if (div < 0) div = 0; //div should never be less than 1 

                $('#pagination_links_foot>:nth-child(' + eval(div + 2) + '').addClass('active');
                AA_searchResultsPage = eval(div + 2) - 1;
                AdlAddUpdateItem('searchResultsPage', AA_searchResultsPage);

                self.limitLinksDisplayed(div);

                util.triggerEvent("search", "selectPage");
            };

            self.JumpToLatestResultsPage = function () {
                var pagePosKey = self.UrlKey.Get(settings.pagePositionKey);

                if (pagePosKey != undefined && pagePosKey >= 1) {
                    var startAt = pagePosKey - 1;
                    var sortBy = self.SortBy();
                    var searchTerms = self.CurrentSearchTerms();

                    self.LoadData(searchTerms, sortBy, startAt);
                }
            }

            self.limitLinksDisplayed = function (currentPage) {
                var currentElem = currentPage + 2;
                var prevLinksInt = 4;
                var nextLinksInt = 1;
                var maxDoNotTruncateInt = 9;
                var ellipsesCalc1 = 5;
                var ellipsesCalc2 = 4;

                // screen width < 480 make mods for mobile devices
                if ($(window).width() < 480) {
                    prevLinksInt = 3;
                    nextLinksInt = 0;
                    maxDoNotTruncateInt = 7;
                    ellipsesCalc1 = 4;
                    ellipsesCalc2 = 3;
                }

                // make previous and next links (first and last elements) a bit wider
                // this had odd behaviour when trying to compound the selector, hence verbosity!

                var paginationLi = $paginationLinks.find("li");

                paginationLi.css("width", "auto");
                paginationLi.first().css("width", "55px");
                paginationLi.last().css("width", "55px");

                // jquery stuff to limit the number of links displayed - if more than 9 links [ Previous | 1-7 | Next ] then use the truncated pagination style 
                var count = paginationLi.length;

                // if 9 or fewer, no need to truncate
                if (count > maxDoNotTruncateInt) {
                    paginationLi.slice(2).addClass('d-none');

                    //jquery has trouble with correctly calculating 'greater than' negative numbers, so set elems lte 3 to zero to avoid negs 
                    if (currentElem <= 4) {
                        paginationLi.slice(1).removeClass('d-none');
                    } else {
                        paginationLi.slice(eval(currentElem - prevLinksInt) + 1).removeClass('d-none');
                    }

                    paginationLi.slice(eval(currentElem + nextLinksInt) + 1).addClass('d-none');
                    paginationLi.slice(eval(count - 2)).removeClass('d-none');

                    //if more than 9 then at least one thing will be hidden

                    $paginationLinks.find("li.d-none").first().after("<span class='temp'>...</span>");

                    if (currentElem > ellipsesCalc1 && eval(count - currentElem) > ellipsesCalc2) {
                        $paginationLinks.find("li.d-none").last().after("<span class='temp'>...</span>");
                    }
                }
            }

            // pagination setup - define array of options
            self.numberOfDisplayResults = ko.observableArray([12, 24, 48]);

            // takes value and create page links
            // 1-12 | 13-24 | ...
            self.PageOptions = ko.observableArray([]);

            self.pagination = ko.computed(function () {
                var total_results = self.TotalResults();
                var interval_val = eval(self.numberOfDisplayResultsSelected());
                var res_1 = 0;
                var res_2 = res_1 + interval_val;
                var res_pg_no = 1;
                var last_pg = 0;

                //clear the array 
                self.PageOptions([]);

                if (total_results > 12) {
                    self.PageOptions.push(
                        {
                            txt: "Prev",
                            css: '',
                            val: -1 //using -1 to identify prev
                        }
                    );

                    while (res_1 < total_results) {
                        if (res_2 > total_results) res_2 = total_results;
                        //(re)populate array
                        var currentPg = Math.floor(self.startAt / 12) + 1;

                        self.PageOptions.push({
                            txt: res_pg_no,
                            val: eval(res_1 + 1),
                            parentcss: (res_pg_no === currentPg) ? 'active' : ''
                        });

                        last_pg = eval(res_1 + 1);
                        res_pg_no++;
                        res_1 = res_2;
                        res_2 = res_1 + interval_val;
                    }

                    if (last_pg > 1) {
                        self.PageOptions.push(
                            {
                                txt: "Next",
                                css: '',
                                val: -2 //using -2 to identify next
                            }
                        );
                    }
                }

                //call function to set up limit on links displayed
                self.limitLinksDisplayed(Math.floor(self.startAt / 12));
            });

            self.OpenSortOptionsDropdown = function () {
                if ($(globalSettings.overallContainer + ' .sortOptionsDropdown').is(':hidden')) {
                    $(globalSettings.overallContainer + ' .sortOptionsDropdown').slideDown(50);
                } else {
                    $(globalSettings.overallContainer + ' .sortOptionsDropdown').slideUp(120);
                }
            };

            self.OpenMapPicture = function (item, e) {
                e.preventDefault();

                var target = e.target.tagName.toLowerCase() === 'a' ? $(e.target) : $(e.target).parents('a');
                var hidden = target.parent();

                if (hidden.hasClass('visible')) {
                    hidden.animate({ "right": "-241px" }, "slow").removeClass('visible');
                    hidden.find('span').css({ "background-position": "left top" });
                } else {
                    hidden.animate({ "right": "0px" }, "slow").addClass('visible');
                    hidden.find('span').css({ "background-position": "-30px top" });
                }
            }

            self.ShowPackageInfo = function (forItem) {
                var data = forItem;
                if (data) {
                    var contentDiv = $('<div/>');
                    if (data.packageStyleImgUrl) {
                        var image = $('<img/>').attr('src', data.packageStyleImgUrl).attr('alt', data.packagestyle).attr('title', data.packagestyle);
                        contentDiv.append(image);
                    }
                    contentDiv.append($('<span />').append(data.packageStyleDesc));
                    dialog.show(data.name, contentDiv);
                }
            };

            self.ShowQRatingPopup = function (forItem) {
                var data = forItem;
                if (data) {
                    var contentDiv = $('<div/>');
                    contentDiv.append($('<div />').append(data.qRatingsText));
                    dialog.show(data.text, contentDiv);
                }
            };
            
            // We throttle this, to make sure we don't make too many calls one after another as things
            // update.  Instead just execute the last (and most up-to-date) caller every 100ms.
            self.LoadData = function (searchTerms, sortBy, startAt) {

                if (!self.Loading) {
                    var loadingDiv = $('<div class="text-center"><img src="/Content/loading.gif" alt="Loading" title="Loading"/></div>');

                    self.Loading = dialog.show("Searching...", loadingDiv, {
                        noClose: true,
                        draggable: false,
                        resizable: false
                    });
                    
                }

                var resultsToGet = self.numberOfDisplayResultsSelected();

                // If we have no results yet, check the URL to see if we have the correct number of results to display in there.
                if (self.SearchResults().length === 0) {
                    // We've got no search results so we're starting from the beginning.
                    //startAt = 0;  this is now set at the top of the page
                    resultsToGet = self.numberOfDisplayResultsSelected();

                    if (!resultsToGet) {
                        // The URL had nothing, just start from 0 and load 12,
                        resultsToGet = self.numberOfDisplayResultsSelected(); // Get selected number of results.;
                    }
                } else if (self.SortBy() !== self.LastSortBy) {
                    self.StartResultsFrom(0);
                    
                }

                self.Service.getResults(sortBy, startAt, resultsToGet, function (resList) {
                    var pRaw = self.UrlKey.Get(settings.searchUrlKey);
                    var p = decodeURIComponent(pRaw);
                    var parameters = p ? JSON.parse(p) : [];

                    // Has the user searched against a date?  If they have, pick the first one and pass it to the search results.
                    var date = _.find(parameters, function (pr) {
                        return pr.type === 'Date';
                    });

                    var passengers = _.find(parameters, function (pr) {
                        return pr.type === 'p';
                    });

                    if (passengers && passengers.value > 0) {
                        self.NumberOfPassengers(parseInt(passengers.value));
                    } else {
                        self.NumberOfPassengers(2);
                    }
                    self.PassengerText = ko.computed(function () {
                        return self.NumberOfPassengers() > 1 ? "passengers" : "passenger";
                    }, this);

                    var searchResults = resList.paginatedResults;

                    _.each(searchResults, function (sr) {
                        if (date) {
                            sr.url += '#app-Phoebe|' + date.value.substring(0, 10);
                            sr.ident.url += '#app-Phoebe|' + date.value.substring(0, 10);
                        }
                    });

                    self.TotalResults(resList.count);

                    // If we have no results to start with, or if the user has changed the sort criteria or their search, then
                    // get a whole new batch of results and reset everything.
                    if (self.SearchResults().length === 0 ||
                        self.SortBy() !== self.LastSortBy ||
                        JSON.stringify(searchTerms) !== JSON.stringify(self.LastSearchTerms)) {
                        // Blow away the search results with a new batch.
                        self.SearchResults(searchResults);
                        self.LastSearchTerms = JSON.parse(JSON.stringify(searchTerms));
                        self.LastSortBy = self.SortBy();

                        // Re-apply the sort criterion, if applicable.
                        var sortedBy = self.UrlKey.Get(settings.sortOrderKey);
                        if (sortedBy) {
                            var decodedSortedBy = decodeURIComponent(sortedBy);
                            self.SortBy(decodedSortedBy);
                            self.LastSortBy = decodedSortedBy;
                        }
                    } else {
                        self.SearchResults(searchResults);
                    }

                    self.Locations(resList.locationPoints);

                    if (self.Loading) {
                        var close = function (msg) {
                            if (msg === "load complete") {
                                if (self.Loading) {
                                    self.Loading.close();
                                    self.Loading = null;
                                }

                                var notifyActivities = window.SearchService["searchResults"].notifyOnActivity;
                                for (var i = 0; i < notifyActivities.length; i++) {
                                    if (notifyActivities[i] === close) {
                                        notifyActivities.splice(i, 1);
                                    }
                                }
                            }
                        };

                        window.SearchService["searchResults"].notifyOnActivity.push(close);

                        util.triggerEvent("search", "loadResults");
                    }

                    self.LoadingFromScroll = false;
                });
                
            };

            var firstLoad = true;

            self.Request = 0;

            var previousSearchTerms = "";
            var previousSortBy = "";
            var previousStartAt = "";

            self.GetData = ko.computed(function () {

                var sortBy = self.SortBy();
                var searchTerms = self.CurrentSearchTerms();
                var startAt = self.startAt; // change to functionality of page - was self.StartResultsFrom();

                //this test will only pass if the user has changed their search criteria on the search results page which allows us to reset the pagination
                if (JSON.stringify(searchTerms) != "[]" && previousSearchTerms != "[]" && previousSearchTerms != JSON.stringify(searchTerms)) {
                    self.startAt = 0;
                    startAt = 0;
                }

                if (previousSearchTerms === JSON.stringify(searchTerms) && previousSortBy === sortBy && startAt === previousStartAt) {
                    return;
                }

                previousSearchTerms = JSON.stringify(searchTerms);
                previousSortBy = sortBy;
                previousStartAt = startAt;

                if (firstLoad) {
                    firstLoad = false;

                    var sorter = self.UrlKey.Get(settings.sortOrderKey);

                    if (sorter) {
                        sortBy = sorter;
                        self.SortBy(decodeURIComponent(sorter));
                    }
                } else {
                    self.UrlKey.Set(settings.sortOrderKey, sortBy);
                }

                self.LoadData(searchTerms, sortBy, startAt);
            }, this);

            // Simple locking to try and prevent multiple reloads on scroll.
            self.LoadingFromScroll = false;

            // When the number of results to display per page changes, update the page
            self.numberOfDisplayResultsChanged = function (obj, event) {
                if (event.originalEvent) { //user changed - only run when changed by user
                    self.LoadingFromScroll = true;

                    var sortBy = self.SortBy();
                    var searchTerms = self.CurrentSearchTerms();
                    var resultsStartFrom = self.numberOfDisplayResultsSelected(); // Get selected number of results.

                    startAt = self.startAt;
                    resultsToGet = self.numberOfDisplayResultsSelected(); // Get selected number of results.

                    self.StartResultsFrom(resultsStartFrom);
                    self.UrlKey.Set(settings.chunkPositionKey, resultsStartFrom);
                    self.LoadData(searchTerms, sortBy, startAt);
                    
                }
            };

            self.Constructor = function () {
                self.Key = self.Service.observe(function () {
                    self.CurrentSearchTerms(self.Service.allTerms());
                });

                // Make sure we don't trigger another postback of the search customisations until we're 
                // all done loading them.
                self.IgnoreChanges = true;
                self.JumpToLatestResultsPage();
            };

            // Run some logic when this object is created.
            self.Constructor();
            
        };
    });
